import { render, staticRenderFns } from "./InstituteDetails.vue?vue&type=template&id=0e3ec230"
import script from "./InstituteDetails.vue?vue&type=script&lang=js"
export * from "./InstituteDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports